import FieldMultiselect from "../../../fields3/generic/multiselect/multiselect";
import FieldUser_MultiselectPopoverOption from "../user/components/multiselect/popover-option";
import FieldConfig from "../../proto/field-config";
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups";
import FieldUsers_ManagementPreview from "./render/management-preview";
import FieldString_ManagementForm from "../string/render/management-form";
import FieldUsers_Pill from "./components/pill";
import FieldUsers_GlistView from "./render/glist-view";
import FieldUsers_AutomationTriggerForm from "./render/automation-trigger";
import FieldUsers_AutomationConditionForm from "./render/automation-condition";
import FieldUsers_AutomationActionForm from "./render/automation-action";
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module";
import mapByUserName from "../../import/normalize/map-user";
import FieldUsers_View from "./render/view"
import {FieldFilterType} from "../../proto/types";

export default class FieldUsers extends FieldMultiselect {

    public arValueOption                : boolean
    public assignedToValueOption        : boolean
    public currentUserValueOption       : boolean

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Users";
        this.filterType         = FieldFilterType.USER;
        this.typeGroup          = GROUP_MISC
        this.typeDescription    = "Company user multiple selection field"
        this.icon               = 'i5-users';

        this.noValueOptionLabel = _.get(config,'noValueOptionLabel','Not assigned');
        this.placeholder        = _.get(config,'placeholder','Not assigned');

        // this.options MAY BE PASSED in constructor (!!!)
        // If no options passed - add all users from the company
        if (!config.options || config.options.length < 1) {

            // In shared view we don't have all users gd.users ... so need filter
            this.options = []
            gd.session.companyUsers.filterByCompany(gd.companyId).map((cu:any)=> {
                if (cu.user) {
                    // @ts-ignore
                    this.options.push({
                        value: cu.user.id,
                        label: cu.user.name
                    })
                }
            })

            // this.options = gd.session.companyUsers.filterByCompany(gd.companyId).map((cu:any)=>({
            //     value: cu.user.id,
            //     label: cu.user.name
            // }));
        }

        // Start addon options

        this.arValueOption              = _.get(config,'arValueOption',false) // if true will add action required value option to options list (by default false)
        this.assignedToValueOption      = _.get(config,'assignedToValueOption',false) // if true will add assigned to value option to options list (by default false)
        this.currentUserValueOption   = _.get(config,'currentUserValueOption',false) // if true will add current user to value option to options list (by default false)

        if (this.arValueOption) {
            // @ts-ignore
            this.options.unshift({
                value: '{actionRequiredUserId}',
                label: 'Action required user',
                icon: 'i5-user'
            })
        }
        if (this.assignedToValueOption) {
            // @ts-ignore
            this.options.unshift({
                value: '{assignedToUserId}',
                label: 'Assigned to user',
                icon: 'i5-user'
            })
        }
        if (this.currentUserValueOption) {
            // @ts-ignore
            this.options.unshift({
                value: '{currentUserId}',
                label: 'Current user',
                icon: 'i5-user'
            })
        }
        // end addon options

        this.components.PopoverOption   = FieldUser_MultiselectPopoverOption // FieldDropdown_PopoverOptionUser
        this.components.PopoverMenuMore = null
        this.components.Pill            = FieldUsers_Pill


        this.classes = _.assign({}, this.classes, {
            PopoverMenu                 : 'min-w-200',
            PopoverMenuScrollContainer  : 'max-h-300',
        })


        this.renderComponents.view                    = FieldUsers_View
        this.renderComponents.glistView               = FieldUsers_GlistView
        this.renderComponents.managementForm          = FieldString_ManagementForm
        this.renderComponents.managementPreview       = FieldUsers_ManagementPreview
        this.renderComponents.automationTriggerForm   = FieldUsers_AutomationTriggerForm
        this.renderComponents.automationConditionForm = FieldUsers_AutomationConditionForm
        this.renderComponents.automationActionForm    = FieldUsers_AutomationActionForm

        // this.renderComponents.editable                = FieldUsers_Editable
        // this.renderComponents.tableCell               = FieldUsers_TableCell

    }

    getOptions(): { label: string; value: null }[] {
        return _.orderBy(super.getOptions(), option=>option.label)
    }

    // for compatibility with ListItems
    _getModelValue(model:any) {
        return model[this.fieldId] ? model[this.fieldId] : _.get(model, 'customFieldsData.{0}'.f(this.fieldId), null);
    }

    public _getOptions(values:any[]):any {

        // value is array
        if (!_.isArray(values)) return false

        if (values) {
            /*const options = _.filter(this.getOptions(), (option) => {
                return values.includes(option.value)
            });*/

            // show all users in values, not only that are present in the options
            const options = _(values)
                .map((userId: ID) => {
                    const user = gd.session.users.get(userId)
                    if (user) {
                        return {
                            value: user.id,
                            label: user.name
                        }
                    }
                })
                .compact()
                .value()

            if (!_.isEmpty(options)) {
                return options
            }
        }

        return false
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        let selectedValues: string[] = value ? value.split(', ') : []
        selectedValues = _.map(selectedValues, (value: string) => value.toLowerCase())

        const ids: string[] = []
        _.map(selectedValues, (value: string): void => {
            const userId: string | null = mapByUserName(gd.companyId, value)
            if (userId) ids.push(userId)
        })

        return ids
    }
}
